import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { DialogContent, Stack, TextField } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardAlertInfo } from "../../../../alert/StandardAlertInfo"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import { StandardButton } from "../../../../buttons/StandardButton"

const useStyles = makeStyles()((_theme) => ({
    dialogContent: {
        padding: "2rem",
        display: "flex",
        gap: "2.5rem",
        flexDirection: "column",
    },
}))

type CreateUpdateDeliveryNoteDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    note: string
    handleChangeNote: (val: string) => void
}>

const MAX_LENGTH = 1000

export function CreateUpdateDeliveryNoteDialog({
    open,
    onClose,
    note,
    handleChangeNote,
}: CreateUpdateDeliveryNoteDialogProps) {
    const { classes } = useStyles()

    const [localNote, setLocalNote] = useState(note)

    const handleSave = () => {
        handleChangeNote(localNote)
        onClose()
    }

    const remainingChars = MAX_LENGTH - localNote.length

    return (
        <LocalizedStrict id="create-order-note-dialog-title" attrs={{ dialogTitle: true }}>
            <StandardDialog dialogTitle="Order message" open={open} onClose={onClose} maxWidthProp="md" scroll="body">
                <DialogContent className={classes.dialogContent}>
                    <LocalizedStrict id="create-order-note-dialog-alert" attrs={{ title: true }}>
                        <StandardAlertInfo title="Your order notification will be visible on the order specification. You must not include personally identifiable information, such as details about your health or your religion." />
                    </LocalizedStrict>
                    <LocalizedStrict
                        id="create-order-note-dialog-field"
                        attrs={{ helperText: true, label: true }}
                        vars={{ count: remainingChars }}
                    >
                        <TextField
                            label="Your order message"
                            value={localNote}
                            multiline
                            rows={5}
                            variant="outlined"
                            inputProps={{ maxLength: MAX_LENGTH }}
                            onChange={(e) => setLocalNote(e.target.value)}
                            helperText="Remaining characters"
                        />
                    </LocalizedStrict>
                    <Stack justifyContent="center" flexDirection="row">
                        <LocalizedStrict id="create-order-note-save-button">
                            <StandardButton variant="contained" fullWidth={false} onClick={handleSave}>
                                Save
                            </StandardButton>
                        </LocalizedStrict>
                    </Stack>
                </DialogContent>
            </StandardDialog>
        </LocalizedStrict>
    )
}
